import { Component } from 'react'
import { connect } from 'react-redux'
import { saveMyJobsDataViewerFilters } from 'reducers/profile/reducer'

class ObserverFilter extends Component {
  shouldComponentUpdate(nextProps) {
    const { profileDataViewerFilters, saveMyJobsDataViewerFilters } = nextProps

    if (this.props.profileDataViewerFilters !== profileDataViewerFilters) {
      saveMyJobsDataViewerFilters({
        jobs_data_viewer_filters: profileDataViewerFilters.toJS(),
      })
    }

    return false
  }

  render() {
    return null
  }
}

export default connect(
  store => ({
    profileDataViewerFilters: store.getIn(['profile', 'jobsDataViewerFilters']),
  }),
  {
    saveMyJobsDataViewerFilters,
  },
)(ObserverFilter)
